import { PInlineNotification } from '@porsche-design-system/components-react';
import { type WarningMessageBoxProps } from '../default/WarningMessageBox';

const WarningMessageBox = ({ message, description }: Omit<WarningMessageBoxProps, 'icon'>) => (
    <PInlineNotification dismissButton={false} state="warning">
        <span slot="heading">{message}</span>
        {description}
    </PInlineNotification>
);

export default WarningMessageBox;
